(function () {
    'use strict';

    angular
        .module('app.tasks')
        .controller('TaskTemplateDetailController', TaskTemplateDetailController);

    TaskTemplateDetailController.$inject = [
        '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'dataservice', '$window', '$timeout'
    ];

    function TaskTemplateDetailController($state, $stateParams,
        bsDialog, common, dataservice, $window, $timeout) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;
        vm.isNew = isNew;
        vm.departments = [];
 
        activate();

        function activate() {
            var promises = [getItem(), initLookups()];
            return common.$q.all(promises).then(function (data) {
            }, function (error) { });
            
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("tasks.templates");
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Task Template')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/Tasks/DeleteTemplate/" + vm.item.UId).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function isNew() {
            var val = $stateParams.uid; 
            return val === "";
        }

        function initLookups() {
            return dataservice.getItem("api/Departments/Active")
                .then(function (response) {
                    if (response) {
                        vm.departments = response.data;
                    }
                }).catch(function (error) {
                    logger.error('Error loading departments');
                    
                });
        }

        function getItem() {
            var val = $stateParams.uid;
            
            if (val === '') {
                vm.item = {};
                vm.item.IncludeFinishBy = 0;
                var d = new Date();
                vm.item.DepartmentIds = [parseInt($window.localStorage.getItem("SevenPointTaskDepartmentId")) || 0];
                vm.item.StartAtDisplay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 6, 0, 0, 0)
                vm.item.FinishByDisplay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 17, 0, 0, 0);
            }
            else {
                return dataservice.getItem("api/Tasks/Template/" + val)
                    .then(function (response) {
                        if (response) {
                            vm.item = response.data;
                            
                            vm.item.StartAtDisplay = moment(vm.item.StartAtDisplay.substr(0, 16)).toDate();
                            if (vm.item.FinishByDisplay !== null) {
                                vm.item.IncludeFinishBy = 1;
                                vm.item.FinishByDisplay = moment(vm.item.FinishByDisplay.substr(0, 16)).toDate();
                            }
                            else {
                                vm.item.IncludeFinishBy = 0;
                                var d = new Date();
                                vm.item.FinishByDisplay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 17, 0, 0, 0);
                            }
                        }
                    })
                    .catch(function (error) {
                        logger.error('Error while getting item with id = ' + val + '; ' + error);
                        $state.go('404');
                    });
            }
        }


        function save() {
            var fromLocal = common.buildDateTime(new Date(), vm.item.StartAtDisplay);
            
            if (vm.item.IncludeFinishBy == 1) {
                
                var toLocal = common.buildDateTime(fromLocal, vm.item.FinishByDisplay);
                if (toLocal < fromLocal) {
                    logger.error("Finish By must be after Start At")
                    return;
                }
                vm.item.FinishBy = moment(toLocal).format("HH:mm");
            }
            else {
                vm.item.FinishBy = null;
            }

            vm.item.StartAt = moment(fromLocal).format("HH:mm");
            vm.isSaving = true;
            dataservice.saveItem('api/Tasks/SaveTemplate', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }
       
    }
})();
